import { Badge } from 'foundations-components/transitional/components/Badge';
import { translateProductType } from '../../utils/translateProductType';
import { jsx as _jsx } from "react/jsx-runtime";
export function ProductTypeBadge({
  productType,
  agentType
}) {
  return /*#__PURE__*/_jsx(Badge, {
    use: "koala",
    children: translateProductType(productType, agentType)
  });
}